var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshCircleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m4.058-15a.75.75 0 0 0-1.5 0v1.099c-.804-.678-1.843-1.218-3.058-1.218-3.282 0-5.25 2.964-5.25 5.434s1.968 5.435 5.25 5.435 5.25-2.964 5.25-5.435a.75.75 0 0 0-1.5 0c0 1.854-1.494 3.935-3.75 3.935s-3.75-2.08-3.75-3.935 1.494-3.934 3.75-3.934c.816 0 1.576.405 2.19.95h-.99a.75.75 0 0 0 0 1.5h2.608a.75.75 0 0 0 .75-.75z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshCircleFill);
export default __webpack_public_path__ + "static/media/refresh_circle_fill.5abf045aa767ca7a08b5d700555bd500.svg";
export { ForwardRef as ReactComponent };